<template>
  <div class="list-tabs">
    <div class="list-tabs__container">
      <button
        v-for="(tab, i) in tabData"
        :key="`Tab${i}`"
        class="list-tab"
        type="button"
        :class="tab.class"
        :title="tab.label"
        @click="setTab(i)"
      >
        {{ tab.label }}
      </button>
    </div>
    <div class="list-tabs__border">
      <span class="list-tabs__border-highlight" :class="tabWidthClass" :style="highlightStyle" />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    highlightStyle() {
      return `transform: translateX(${this.activeIndex * 100}%);`
    },
    tabData() {
      return this.tabs.map((tab, i) => {
        return {
          class: `${this.tabWidthClass}${i === this.activeIndex ? ' list-tab--active' : ''}`,
          label: this.$t(`${this.titlePrefix}.${tab}`),
        }
      })
    },
    tabWidthClass() {
      if (this.tabs.length > 1) {
        return `w-1/${this.tabs.length}`
      }
      return 'w-full'
    },
  },
  methods: {
    setTab(tabIndex) {
      // Emit active tab index change
      if (tabIndex !== this.activeIndex) {
        this.$emit('tab-change', tabIndex)
      }
    },
  },
  props: {
    activeIndex: {
      default: 0,
      type: Number,
    },
    tabs: {
      default: () => [],
      type: Array,
    },
    titlePrefix: {
      default: 'jobRelated',
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.list-tabs {
  /* Sticky tabs, fallback to position: relative */
  @apply relative sticky top-0 mx-2 mb-6;

  &:after {
    @apply absolute inset-y-0 z-0 bg-grey-bg;
    content: '';
    left: -0.5rem;
    width: calc(100% + 1rem);
  }
}

.list-tabs__container {
  @apply flex items-center;
  @apply w-full max-w-form mx-auto;
}
.list-tab {
  @apply relative p-3 z-1;
  @apply text-sm text-center leading-snug text-grey-400;
  min-height: 2.75rem;

  &:hover {
    @apply text-red-500;
  }
  &:focus {
    @apply outline-none;
  }
  &.list-tab--active {
    @apply font-bold text-red-500;
  }
}

.list-tabs__border {
  @apply relative mx-auto z-2;
  @apply w-full max-w-form;
  @apply bg-transparent overflow-hidden;
  height: 2px;
  margin-top: -2px;
}
.list-tabs__border-highlight {
  @apply absolute inset-y-0 left-0 bg-red-500;
  transform-origin: center center;
  transition: transform 0.2s ease;
}

@screen desktop {
  .list-tabs {
    @apply mx-0;
  }
  .list-tabs:after {
    @apply left-0 w-full;
  }
  .list-tab {
    @apply p-4 text-17/4;
  }
}
</style>
